import { func } from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import Jackpots from 'calendar/components/Jackpots';
import { fetchAtgJackpots, fetchSportJackpots } from 'calendar/redux/actions';
import { calendar } from 'calendar/redux/selectors';

const mapStateToProps = state => ({
  jackpots: calendar.getJackpots(state),
  hasJackpots: calendar.hasJackpots(state),
  error: calendar.getJackpotsError(state),
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      fetchAtgJackpots,
      fetchSportJackpots,
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(
  class JackpotContainer extends Component {
    static propTypes = {
      onCreateAtgBet: func.isRequired,
      onCreateSportBet: func.isRequired,
    };

    componentDidMount() {
      const { fetchAtgJackpots, fetchSportJackpots } = this.props;
      fetchAtgJackpots();
      fetchSportJackpots();
    }

    onCreateBetClick = jackpot => {
      const { onCreateAtgBet, onCreateSportBet } = this.props;
      const { isSport, isAtg, betParams } = jackpot;
      if (isAtg) {
        onCreateAtgBet(betParams);
      } else if (isSport) {
        onCreateSportBet(betParams);
      }
    };

    render() {
      const { jackpots, hasJackpots, error } = this.props;

      return (
        <Jackpots
          jackpots={jackpots}
          hasJackpots={hasJackpots}
          error={error}
          onItemClick={this.onCreateBetClick}
        />
      );
    }
  },
);
